import script from "./PatientTableHeader.vue?vue&type=script&lang=ts&setup=true"
export * from "./PatientTableHeader.vue?vue&type=script&lang=ts&setup=true"

import "./PatientTableHeader.vue?vue&type=style&index=0&id=51f6fd25&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-51f6fd25"]])

export default __exports__